export const vertiNodeAppName = "VertiNode";
